var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-5",attrs:{"id":"admin-types-tables"}},[_c('v-container',{staticClass:"h-100 d-flex flex-column pt-0"},[_c('v-row',[(_vm.isPermittedAll([
          'CallStatusCreate',
        ]))?_c('v-col',{attrs:{"cols":_vm.isMobile ? 12 : 6}},[_c('div',{staticClass:"d-flex align-end"},[_c('label',{staticClass:"line-height-1 mb-1"},[_vm._v("Call Statuses:")]),_c('div',{staticClass:"ml-auto"},[_c('v-btn',{staticClass:"square mb-2",attrs:{"title":"Add Call Status","type":"button","color":"primary","disabled":_vm.$store.getters.isLoadingActive,"block":""},on:{"click":function($event){return _vm.$store.dispatch(
                  'openCodeModalForm',
                  {
                    config: {
                      entity: 'Call Status',
                      property: 'CallStatusName',
                      createEndpoint: 'Calls/CreateCallStatus',
                      refresh: {
                        getEndpoint: 'Calls/GetAllCallStatus',
                        list: 'callStatuses',
                      },
                    },
                  },
                )}}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],1)]),_c('v-data-table',{staticClass:"form-table",attrs:{"headers":[
            {
              text: 'Call Status',
              value: 'CallStatusName',
            },
          ],"items":_vm.$store.state.callStatuses,"mobile-breakpoint":"-1","item-key":"CallStatusID","dense":"","disable-pagination":"","hide-default-footer":"","fixed-header":"","options":{
            sortBy: ['CallStatusName'],
            rowsPerPage: -1,
          }},scopedSlots:_vm._u([{key:"item",fn:function(row){return [_c('tr',[_c('td',[_vm._v(_vm._s(row.item.CallStatusName))])])]}}],null,false,1676525051)})],1):_vm._e(),(_vm.isPermittedAll([
          'CallTypesCreate',
        ]))?_c('v-col',{attrs:{"cols":_vm.isMobile ? 12 : 6}},[_c('div',{staticClass:"d-flex align-end"},[_c('label',{staticClass:"line-height-1 mb-1"},[_vm._v("Call Types:")]),_c('div',{staticClass:"ml-auto"},[_c('v-btn',{staticClass:"square mb-2",attrs:{"title":"Add Call Type","type":"button","color":"primary","disabled":_vm.$store.getters.isLoadingActive,"block":""},on:{"click":function($event){return _vm.$store.dispatch(
                  'openCodeModalForm',
                  {
                    config: {
                      entity: 'Call Type',
                      property: 'CallTypeName',
                      createEndpoint: 'Calls/CreateCallType',
                      refresh: {
                        getEndpoint: 'Calls/GetAllCallTypes',
                        list: 'callTypes',
                      },
                    },
                  },
                )}}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],1)]),_c('v-data-table',{staticClass:"form-table",attrs:{"headers":[
            {
              text: 'Call Type',
              value: 'CallTypeName',
            },
          ],"items":_vm.$store.state.callTypes,"mobile-breakpoint":"-1","item-key":"CallTypeID","dense":"","disable-pagination":"","hide-default-footer":"","fixed-header":"","options":{
            sortBy: ['CallTypeName'],
            rowsPerPage: -1,
          }},scopedSlots:_vm._u([{key:"item",fn:function(row){return [_c('tr',[_c('td',[_vm._v(_vm._s(row.item.CallTypeName))])])]}}],null,false,2877433559)})],1):_vm._e()],1),_c('v-row',[(_vm.isPermittedAll([
          'CustomerTypesCreate',
        ]))?_c('v-col',{attrs:{"cols":_vm.isMobile ? 12 : 6}},[_c('div',{staticClass:"d-flex align-end"},[_c('label',{staticClass:"line-height-1 mb-1"},[_vm._v("Customer Types:")]),_c('div',{staticClass:"ml-auto"},[_c('v-btn',{staticClass:"square mb-2",attrs:{"title":"Add Customer Type","type":"button","color":"primary","disabled":_vm.$store.getters.isLoadingActive,"block":""},on:{"click":function($event){return _vm.$store.dispatch(
                  'openCodeModalForm',
                  {
                    config: {
                      entity: 'Customer Type',
                      property: 'CustomerTypeName',
                      createEndpoint: 'Customers/CreateCustomerType',
                      refresh: {
                        getEndpoint: 'Customers/GetAllCustomerTypes',
                        list: 'customerTypes',
                      },
                    },
                  },
                )}}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],1)]),_c('v-data-table',{staticClass:"form-table",attrs:{"headers":[
            {
              text: 'Customer Type',
              value: 'CustomerTypeName',
            },
          ],"items":_vm.$store.state.customerTypes,"mobile-breakpoint":"-1","item-key":"CustomerTypeID","dense":"","disable-pagination":"","hide-default-footer":"","fixed-header":"","options":{
            sortBy: ['CustomerTypeName'],
            rowsPerPage: -1,
          }},scopedSlots:_vm._u([{key:"item",fn:function(row){return [_c('tr',[_c('td',[_vm._v(_vm._s(row.item.CustomerTypeName))])])]}}],null,false,2443048049)})],1):_vm._e(),(_vm.isPermittedAll([
          'EmployeeTitlesCreate',
        ]))?_c('v-col',{attrs:{"cols":_vm.isMobile ? 12 : 6}},[_c('div',{staticClass:"d-flex align-end"},[_c('label',{staticClass:"line-height-1 mb-1"},[_vm._v("Employee Titles:")]),_c('div',{staticClass:"ml-auto"},[_c('v-btn',{staticClass:"square mb-2",attrs:{"title":"Add Employee Title","type":"button","color":"primary","disabled":_vm.$store.getters.isLoadingActive,"block":""},on:{"click":function($event){return _vm.$store.dispatch(
                  'openCodeModalForm',
                  {
                    config: {
                      entity: 'Employee Title',
                      property: 'EmployeeTitleName',
                      createEndpoint: 'Employees/CreateEmployeeTitle',
                      refresh: {
                        getEndpoint: 'Employees/GetAllEmployeeTitles',
                        list: 'employeeTitles',
                      },
                    },
                  },
                )}}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],1)]),_c('v-data-table',{staticClass:"form-table",attrs:{"headers":[
            {
              text: 'Employee Title',
              value: 'EmployeeTitleName',
            },
          ],"items":_vm.$store.state.employeeTitles,"mobile-breakpoint":"-1","item-key":"EmployeeTitleID","dense":"","disable-pagination":"","hide-default-footer":"","fixed-header":"","options":{
            sortBy: ['EmployeeTitleName'],
            rowsPerPage: -1,
          }},scopedSlots:_vm._u([{key:"item",fn:function(row){return [_c('tr',[_c('td',[_vm._v(_vm._s(row.item.EmployeeTitleName))])])]}}],null,false,2067227055)})],1):_vm._e()],1),_c('v-row',[(_vm.isPermittedAll([
          'SoftwareTypesCreate',
        ]))?_c('v-col',{attrs:{"cols":_vm.isMobile ? 12 : 6}},[_c('div',{staticClass:"d-flex align-end"},[_c('label',{staticClass:"line-height-1 mb-1"},[_vm._v("Software Types:")]),_c('div',{staticClass:"ml-auto"},[_c('v-btn',{staticClass:"square mb-2",attrs:{"title":"Add Software Type","type":"button","color":"primary","disabled":_vm.$store.getters.isLoadingActive,"block":""},on:{"click":function($event){return _vm.$store.dispatch(
                  'openCodeModalForm',
                  {
                    config: {
                      entity: 'Software Type',
                      property: 'SoftwareTypeName',
                      createEndpoint: 'Computers/CreateSoftwareType',
                      refresh: {
                        getEndpoint: 'Computers/GetAllSoftwareTypes',
                        list: 'softwareTypes',
                      },
                    },
                  },
                )}}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],1)]),_c('v-data-table',{staticClass:"form-table",attrs:{"headers":[
            {
              text: 'Software Types',
              value: 'SoftwareTypeName',
            },
          ],"items":_vm.$store.state.softwareTypes,"mobile-breakpoint":"-1","item-key":"SoftwareTypeID","dense":"","disable-pagination":"","hide-default-footer":"","fixed-header":"","options":{
            sortBy: ['SoftwareTypeName'],
            rowsPerPage: -1,
          }},scopedSlots:_vm._u([{key:"item",fn:function(row){return [_c('tr',[(row.item.SoftwareTypeIsDeleted)?_c('td',[_vm._v(" "+_vm._s(row.item.SoftwareTypeName)+" "),_c('v-icon',{on:{"click":function($event){return _vm.handleSoftwareTypeHiding(row.item)}}},[_vm._v("mdi-eye-off")])],1):_c('td',[_vm._v(" "+_vm._s(row.item.SoftwareTypeName)+" "),_c('v-icon',{on:{"click":function($event){return _vm.handleSoftwareTypeHiding(row.item)}}},[_vm._v("mdi-eye-outline")])],1)])]}}],null,false,3547840787)})],1):_vm._e(),(_vm.isPermittedAll([
          'PurchasingVendorsCreate',
        ]))?_c('v-col',{attrs:{"cols":_vm.isMobile ? 12 : 6}},[_c('div',{staticClass:"d-flex align-end"},[_c('label',{staticClass:"line-height-1 mb-1"},[_vm._v("Purchasing Vendors:")]),_c('div',{staticClass:"ml-auto"},[_c('v-btn',{staticClass:"square mb-2",attrs:{"title":"Add Purchasing Vendor","type":"button","color":"primary","disabled":_vm.$store.getters.isLoadingActive,"block":""},on:{"click":function($event){return _vm.$store.dispatch(
                  'openCodeModalForm',
                  {
                    config: {
                      entity: 'Purchasing Vendor',
                      property: 'PurchasingVendorName',
                      createEndpoint: 'Computers/CreatePurchasingVendor',
                      refresh: {
                        getEndpoint: 'Computers/GetAllPurchasingVendors',
                        list: 'purchasingVendors',
                      },
                    },
                  },
                )}}},[_c('v-icon',[_vm._v("mdi-plus")])],1)],1)]),_c('v-data-table',{staticClass:"form-table",attrs:{"headers":[
            {
              text: 'Purchasing Vendor',
              value: 'PurchasingVendorName',
            },
          ],"items":_vm.$store.state.purchasingVendors,"mobile-breakpoint":"-1","item-key":"PurchasingVendorID","dense":"","disable-pagination":"","hide-default-footer":"","fixed-header":"","options":{
            sortBy: ['PurchasingVendorName'],
            rowsPerPage: -1,
          }},scopedSlots:_vm._u([{key:"item",fn:function(row){return [_c('tr',[_c('td',[_vm._v(_vm._s(row.item.PurchasingVendorName))])])]}}],null,false,2278498023)})],1):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }